import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { ResumeSkillSchema } from "../../../validation/validator";
import Form from "react-bootstrap/Form";
import { RootState } from "../../../store/store";
import { setResumeDetails } from "../../../store/resume.store";
import { useCustomNavigate } from "../../../hooks/useCustomNavigate";

import { TagsInput } from "react-tag-input-component";
import { AppRoute } from "../../../router/routerConstants";

const AddSkillModal = ({ show, onClose, isEdit }: any) => {
  const dispatch = useDispatch();

  const { resumeDetails } = useSelector(
    (state: RootState) => state.resumeSlice
  );
  const { user } = useSelector((state: RootState) => state.authSlice);
  const [NavigateTo] = useCustomNavigate();

  const [skill, setSkill] = useState({ skills: [] });

  useEffect(() => {
    if (resumeDetails?.skills) {
      setSkill({ skills: resumeDetails?.skills });
    }
  }, [resumeDetails, isEdit]);

  const handleSubmit = (values: any) => {
    const updatedDetails = {
      ...resumeDetails,
      skills: values.skills,
    };
    dispatch(setResumeDetails(updatedDetails));
    onClose();
    if (user && user?.role === "jobseeker") {
      NavigateTo(AppRoute.JOBSEEKER_AFTER_ADDED_QUALIFICATIONS);
    } else if (user && user?.role === "localagents") {
      NavigateTo(AppRoute.AGENT_AFTER_ADDED_QUALIFICATIONS);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      animation={false}
      aria-labelledby="contained-modal-title-vcenter"
      className="editPersonalInformation"
      centered
    >
      <button
        type="button"
        className="btn-close custom-close-btn"
        onClick={onClose}
        aria-label="Close"
        style={{
          position: "absolute",
          top: "20px",
          right: "20px",
          zIndex: 9,

          border: "none",
          fontSize: "1rem",
          cursor: "pointer",
        }}
      ></button>
      <Modal.Body>
        <div className="findbody">
          <h3>{isEdit ? "Edit" : "Add"} Skills</h3>
          <Formik
            initialValues={skill}
            validationSchema={ResumeSkillSchema}
            onSubmit={handleSubmit}
          >
            {({
              setFieldValue,
              values,
              errors,
              touched,
              handleBlur,
              handleSubmit,
            }) => (
              <Form className="modalSearch" onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Qualification{" "}
                    <span className="text-danger">
                      ( Press Enter after entering a value. )
                    </span>
                  </Form.Label>
                  <TagsInput
                    value={values.skills}
                    onChange={(newTags) => setFieldValue("skills", newTags)}
                    onBlur={handleBlur}
                    name="skills"
                    placeHolder="Enter skill"
                  />
                  {touched.skills && errors.skills && (
                    <div className="text-danger mt-2">{errors.skills}</div>
                  )}
                </Form.Group>

                <div className="d-flex gp-10">
                  <Button className="btn w-100" type="submit">
                    {isEdit ? "Update" : "Save"}
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddSkillModal;
